import { useEffect } from "react";

/**
 * handleClickOutside - Attach an event listener to the document and invoke the given callback whenever a click happens outside of the given element.
 *
 * @param {RefObject} ref - A ref of the element.
 * @param {function} callback - The function to call when clicked outside of the element.
 */

export default function handleClickOutsideElement(refs, callback) {
  const refList = Array.isArray(refs) ? refs : [refs];

  useEffect(() => {
    /**
     * Invoke callback if click is on outside of element
     */
    function _handleClickOutside(event) {
      const isInside = refList.some((ref) => ref?.current && ref.current.contains(event.target));
      if (!isInside) {
        callback();
      }
    }

    // Attach the event listener to the entire document
    document.addEventListener("mousedown", _handleClickOutside);
    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", _handleClickOutside);
    };
  }, [callback, ...refList]); // Depend on refs and callback
}
